import { lazy } from 'react';

import type { Policy } from '@cartwhl/common/appletPolicy';

import type { AppletDefinition } from '../../applets';
import CanvasLayout from '../CanvasLayout';
import CanvasLayoutAccessDenied from '../CanvasLayout/CanvasLayoutAccessDenied';
import CanvasLayoutLoading from '../CanvasLayout/CanvasLayoutLoading';
import { MOTION_EDITOR_PATH } from './core/routing';

const MotionEditorRoute = lazy(
  () => import('./shell/routes/MotionEditorRoute'),
);

const applet = {
  id: 'motion-editor',
  path: MOTION_EDITOR_PATH,
  paths: [
    '/motion-viewer',
    '/motion-viewer/create/:motionID',
    '/motion-viewer/:sceneID',
    MOTION_EDITOR_PATH,
    `${MOTION_EDITOR_PATH}/create/:motionID`,
    `${MOTION_EDITOR_PATH}/:sceneID`,
  ],
  label: 'Motion Editor',
  description: 'Generative editing and reshaping',
  dashboard: {
    badge: 'New',
    videoSrc:
      'https://resources.getcartwheel.com/share/demo-videos/05_motion_editor_dashboard_output.webm',
    title: 'Motion Editor',
    description: 'Generative editing and reshaping',
    order: 25,
  },
  policy: {
    requiresAdmin: false,
    requiresApiKey: 'soft',
  } satisfies Policy,
  component: MotionEditorRoute,
  layout: CanvasLayout,
  loading: CanvasLayoutLoading,
  accessDenied: CanvasLayoutAccessDenied,
} satisfies AppletDefinition;

export default applet;
